module.exports = __webpack_public_path__ + "static/media/welcomeDemo2.78e8726e.png";